// 通知预渲染插件：当前页正文已经准备好，可以抓取

export function signalPrerenderReady() {
  if (typeof document === 'undefined' || window.__prerenderReady) return
  window.__prerenderReady = true
  document.dispatchEvent(new Event('render-event'))
}



// WEBPACK FOOTER //
// ./src/utils/prerender.js